import { writable } from "svelte/store";
import { createEvent, fetchEvents } from "../connections/events";
import type { EventQuery, Event } from "@commons/types/Events";

function initializeEvents() {
  const { subscribe, update, set } = writable<Record<string, Promise<Event[]>>>(
    {},
  );
  let eventsMap: Record<string, Promise<Event[]>> = {};
  const loadingEvents = writable(true);

  return {
    loadingEvents,
    subscribe,
    getEvents: async (query: EventQuery) => {
      if (Array.isArray(query.calendarIDs) && query.calendarIDs.length > 0) {
        loadingEvents.set(true);

        const queryKey = JSON.stringify(query);
        if (
          !eventsMap[queryKey] &&
          (query.component_id || query.access_token)
        ) {
          eventsMap[queryKey] = fetchEvents(query);

          update((events) => {
            events[queryKey] = eventsMap[queryKey];
            return { ...events };
          });
        }

        const events = await eventsMap[queryKey];

        loadingEvents.set(false);

        return events;
      }
    },
    createEvent: async (event: Event, query: EventQuery) => {
      const queryKey = JSON.stringify(query);
      const _event = await eventsMap[queryKey];
      if (_event) {
        eventsMap[queryKey] = Promise.all([
          eventsMap[queryKey],
          createEvent(event, query),
        ]).then((events) => {
          return events.flat();
        });
      } else {
        eventsMap[queryKey] = createEvent(event, query).then((event) => {
          return [event];
        });
      }

      update((events) => {
        events[queryKey] = eventsMap[queryKey];
        return { ...events };
      });
    },
    reset: () => {
      eventsMap = {};
      set({});
    },
  };
}

export const EventStore = initializeEvents();
